import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
	selector: 'optional-date-picker-dialog',
	templateUrl: './optional-date-picker-dialog.component.html',
	styleUrls: ['./optional-date-picker-dialog.component.scss'],
	standalone: false
})
export class OptionalDatePickerDialogComponent implements OnInit, OnDestroy {
	public readonly destroy$ = new Subject<void>();

	public form: UntypedFormGroup = new UntypedFormGroup({
		start_date: new UntypedFormControl(null),
		end_date: new UntypedFormControl(null)
	});

	constructor (
		@Inject(MAT_DIALOG_DATA) public data: {
			submitText: string;
			title: string;
		},
		public dialogRef: MatDialogRef<OptionalDatePickerDialogComponent>
	) {}

	public ngOnInit () {
		this.form.addValidators(this.dateRangeValidator);
	}

	public ngOnDestroy (): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	public dismiss () {
		this.dialogRef.close({ dismissed: true });
	}

	public submit (form) {
		if (form.invalid) {
			return;
		}

		this.dialogRef.close({
			start_date: form.controls.start_date.value,
			end_date: form.controls.end_date.value
		});
	}

	private dateRangeValidator: ValidatorFn = (group: AbstractControl): { [key: string]: any } | null => {
		const start = group.get('start_date')?.value;
		const end = group.get('end_date')?.value;

		// Validate only if both dates are provided
		if (start && end && start > end) {
			return { dateRangeInvalid: true };
		}
		return null;
	};
}
